export default __webpack_public_path__ + "static/media/removee_icon.2d1d8d90.svg";